export var DiffState;

!function(DiffState) {
    DiffState.enter = "enter", DiffState.update = "update", DiffState.exit = "exit", 
    DiffState.unChange = "unChange";
}(DiffState || (DiffState = {}));
//# sourceMappingURL=enum.js.map
